import { selectInfraredFlightById } from "features/entity-caching/flights/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { GenericFlightAssetsThumbnail } from "../generics/genericAssetsListThumbnails"
import * as Icons from "@nova/component-icons"
import { useRef, useState, useCallback } from "react"
import { PortalledTooltip } from "features/popups/PortalledTooltip"

export function InfraredImageAssetsThumbnail({ id }: { id: string }) {
    const flight = useAppSelector(selectInfraredFlightById(id))
    const mouseEnterTimeoutRef = useRef<NodeJS.Timeout | null>(null)
    const [isHovering, setIsHovering] = useState(false)
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 })
    const handleMouseMove = useCallback((e: React.MouseEvent) => {
        setMousePos({ x: e.clientX, y: e.clientY })
    }, [])
    const handleMouseEnter = useCallback(() => {
        if (!mouseEnterTimeoutRef.current) {
            mouseEnterTimeoutRef.current = setTimeout(() => setIsHovering(true), 500)
        }
    }, [])
    const handleMouseLeave = useCallback(() => {
        if (mouseEnterTimeoutRef.current) {
            clearTimeout(mouseEnterTimeoutRef.current)
            mouseEnterTimeoutRef.current = null
        }
        setIsHovering(false)
    }, [])
    if (flight?.job?.extraFeatures?.includes("customHotspotUpload")) {
        return (
            <>
                <div
                    className="w-full h-full flex items-center justify-center"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onMouseMove={handleMouseMove}
                >
                    <Icons.SmallIcon Icon={Icons.DownloadFull} iconClassName="text-white-600" />
                </div>
                {isHovering && (
                    <PortalledTooltip initialPosition={mousePos}>
                        <div className="bg-gray-900 rounded-lg border border-gray-700 px-2 py-1 shadow-tooltip">
                            <small className="text-gray-50">
                                This layer was imported from a file.
                            </small>
                        </div>
                    </PortalledTooltip>
                )}
            </>
        )
    }
    return <GenericFlightAssetsThumbnail id={id} />
}
